import React, { Component, Fragment } from 'react'

class DidYouMean extends Component {

  _onClick = e => {
    this.props.push({
      pathname: this.props.spelling.options[0].text
    })
  }

  render() {
 const {options} =this.props.spelling

    return (
      this.props.spelling &&
      (<Fragment>
        {
          options.length ===1 && options[0].text
          &&
          <div className="did-you-mean">Did you mean <a className="facet-link-single" onClick={this._onClick}>{options[0].text}</a> ?</div>
        }
      </Fragment>
    )
    )
  }
}

export default DidYouMean